import React, { PureComponent, Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { deviceInformation } from '../../../helpers/device';
import ErrorMessage from './ErrorMessage';
import PasswordVisibilityToggle from './PasswordVisibilityToggle';
import ErrorTypes from './ErrorTypes';

import './FieldInput.scss';
import PasswordStrengthCheck from '../common/passwordStrengthCheck/PasswordStrengthCheck';

class FieldInput extends PureComponent {
	state = {
		showPassword: this.props.showPassword,
	};

	static propTypes = {
		placeholder: PropTypes.string,
		label: PropTypes.node,
		subLabel: PropTypes.node,
		showPassword: PropTypes.bool,
		maxLength: PropTypes.number,
	};

	static defaultProps = {
		placeholder: null,
		label: null,
		subLabel: null,
		showPassword: false,
		maxLength: null,
	};

	render() {
		const {
			input,
			element,
			autoFocus,
			testId,
			className,
			label,
			placeholder,
			subLabel,
			type,
			meta,
			autocomplete,
			maxLength,
			showPasswordStrengthCheck,
		} = this.props;
		const showError = meta.error && meta.touched;
		const errorType = (ErrorTypes[meta.error] && ErrorTypes[meta.error].type) || 'error';
		const { showPassword } = this.state;
		const elementId = `input-${type}-${input.name}`;
		const isPasswordField = type === 'password';
		/*
		 * Ugly hack, Firefox doesn't support autocomplete="new-password"
		 * so we need to trick firefox, by adding a login form which is hidden.
		 * more information: https://bugzilla.mozilla.org/show_bug.cgi?id=1119063
		 */
		const fakeLoginFields = () => {
			return (
				<Fragment>
					<input type="text" className="onboarding-field-input--hide" />
					<input type="password" className="onboarding-field-input--hide" />
				</Fragment>
			);
		};

		return (
			<div
				className={cx('onboarding__form__input', 'onboarding-field-input', {
					[className]: !!className,
					error: showError,
				})}
			>
				{isPasswordField && autocomplete == 'new-password' && deviceInformation.isFirefox
					? fakeLoginFields()
					: null}

				<input
					{...input}
					type={showPassword ? 'text' : type}
					autoCorrect="off"
					autoCapitalize="off"
					spellCheck="false"
					autoFocus={autoFocus}
					maxLength={maxLength}
					ref={element}
					id={elementId}
					data-test={testId}
					placeholder={placeholder}
					className={cx('onboarding-field-input__field', {
						[`onboarding-field-input__field--${type}`]: type,
						error: showError && errorType === 'error',
					})}
				/>
				<label className="onboarding-field-input__label" htmlFor={elementId}>
					{label}
				</label>

				{isPasswordField && (
					<PasswordVisibilityToggle
						show={showPassword}
						onClick={() => this.setState({ showPassword: !showPassword })}
					/>
				)}

				{subLabel && (
					<div className="onboarding-field-input__sublabel onboarding-field-input__bottom">
						{subLabel}
					</div>
				)}

				{/* do not remove this, is the PasswordStrengthCheck component that send as a prop */}
				{isPasswordField && showPasswordStrengthCheck ? (
					<div className="onboarding-field-input__label onboarding-field-input__bottom">
						<PasswordStrengthCheck password={input.value} showErrors={meta.error} />
					</div>
				) : null}

				{typeof meta.error === 'string' && showError && (
					<ErrorMessage error={meta.error} testId={testId ? `${testId}-error` : null} />
				)}
			</div>
		);
	}
}

export default FieldInput;
